"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "InfiniteLoader", {
  enumerable: true,
  get: function get() {
    return _InfiniteLoader["default"];
  }
});
exports["default"] = void 0;

var _InfiniteLoader = _interopRequireDefault(require("./InfiniteLoader"));

var _default = _InfiniteLoader["default"];
exports["default"] = _default;